module.exports = __webpack_public_path__ + "static/img/icons_order-items.a997b55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_order-items.svg
// module id = X11c
// module chunks = 1